import React, { useState, useEffect, useRef } from "react";
import Modal from "../../components/Modal";
import { debounce } from "lodash";
import { BodyText, Heading } from "../../elements";
import { injectScript } from "../../utils";
import api from "../../utils/api";
import config from "../../temp/config";
import { S_EDITING_CARD, S_USER, webStorage } from "../../utils/webStorage";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";
import { getApiError } from "../../services/siteService";
import { getCulture } from "../../utils/siteUtils";
import { _3dsStatus, bankCardSubTypes } from "../../utils/lynkco-constants";
import CheckoutPaymentFrame from "../checkout-payment-frame";
import getSiteInfo from "../../utils/getSiteInfo";
import { getBankCards } from "../../services/userService";
const containerId = `arvato-${Math.random()
  .toString(16)
  .toString(16)
  .substr(2)}`;
const BankCardModal = ({ fields, visible, onSuccess, onCloseClicked, user }) => {
  const { headingType, headingBody, body, redirectUrl, changeActiveCardFaildMessage, ctaName, colorScheme, iconName, arvatoOptions } = fields;
  console.log("redirectUrl", redirectUrl);
  const { scriptUrl, tokenizationServiceUrl, cssUrl, mandateConfirmationText, paymentMethods } = arvatoOptions.fields;
  const [iframeUrl, setIframeUrl] = useState();
  const arv = useRef();
  const changeBankCardRes = useRef();
  const watcher = useRef();
  const [serverError, setServerError] = useState(null);
  useEffect(() => {
    if (visible) {
      init().catch(ex => {
        console.error(ex);
        getApiError(ex.code).then(error => {
          setServerError(error.body.value);
        });
      });
    }
  }, [visible]);
  const init = async () => {
    if (!global.Arvato) {
      await injectScript(scriptUrl.value);
    }
    const {
      obj: { securityToken, countryCode, currencyCode }
    } = await api.order.payment.init();
    let culture = getCulture();
    if (!arv.current) {
      const arvatoOptions = new global.Arvato.PayNext.WidgetApiOptions();
      arvatoOptions.tokenizationServiceUrl = tokenizationServiceUrl.value;
      arvatoOptions.securityToken = securityToken;
      arvatoOptions.placeHolder = containerId;
      arvatoOptions.countryCode = countryCode; //"NL";
      arvatoOptions.currencyCode = currencyCode; //"EUR";
      arvatoOptions.culture = culture; //"nl-NL";
      console.log(countryCode, currencyCode, culture);
      if (cssUrl.value) {
        let cssLink = cssUrl.value;
        if (!/^http?s/.test(cssLink)) {
          cssLink = `${config.sitecoreApiHost}${cssLink}`;
        }
        arvatoOptions.cssUrl = cssLink;
      }
      arvatoOptions.displayValidationErrors = true;
      arvatoOptions.paymentMethods = paymentMethods.length > 0 ? paymentMethods.map(pm => pm.fields.phrase.value).join(",") : "*";
      arvatoOptions.mandateConfirmationText = mandateConfirmationText?.value || "";
      arvatoOptions.clearFrameAfterSuccessfulPayment = false;
      arvatoOptions.successCallback = successCallback;
      arvatoOptions.errorCallback = errorCallback;
      arvatoOptions.frameWidth = 600;
      arvatoOptions.frameHeight = 360;
      arvatoOptions.renderErrorCallback = renderErrorCallback;
      arvatoOptions.unifiedPaymentMethodLogos = true;
      arvatoOptions.enforcePaymentMethodsOrder = true;
      //optional
      arvatoOptions.firstName = user.firstName;
      arvatoOptions.lastName = user.lastName;
      arvatoOptions.amount = 0;

      //todo = not implemented yet
      // arvatoOptions.timeOut = 3000;
      // arvatoOptions.showCVCHint = false;
      // arvatoOptions.busyIndicator = "";
      arvatoOptions.renderSuccessCallback = renderSuccessCallback;
      arvatoOptions.onWidgetContentResized = resizeCallback; // this will be executed after the widget sends a resize notification
      arvatoOptions.automaticParentResize = true; //when widget content size is changed
      // arvatoOptions.DisableIntroductionText = true;
      const arvInstance = new global.Arvato.PayNext.WidgetApi(arvatoOptions);
      arvInstance.render();
      arv.current = arvInstance;
    } else {
      arv.current.options.amount = 0;
      arv.current.render();
    }
  };
  const startWatchTransaction = (serialNo, bankCardId) => {
    const watching = async () => {
      const res = await api.user.activeCard.transaction(null, {
        serialNo,
        bankCardId
      });
      const { status } = res.obj;
      switch (status) {
        case _3dsStatus.successNoLink:
          onSuccess && onSuccess(res);
          break;
        case _3dsStatus.failed:
          setServerError(changeActiveCardFaildMessage.value);
          break;
        default:
          watcher.current = setTimeout(() => {
            watching();
          }, 500);
          break;
      }
    };
    watching();
  };
  const successCallback = async ({ PaymentToken }) => {
    const card = webStorage.get(S_EDITING_CARD);
    if (card) {
      if (card.data.cardSubType === bankCardSubTypes.actived) {
        const siteInfo = await getSiteInfo();
        const user = webStorage.get(S_USER);
        const resNewCard = await api.user.addBankCard(null, {
          paymentToken: PaymentToken,
          userAccount: user.userAccount
        });
        const { obj: newCardId } = resNewCard;
        const cards = await getBankCards();
        const newCard = cards.find(x => x.id === newCardId);
        const res = await api.user.activeCard.change(null, {
          orgId: siteInfo.organization,
          bankCardId: newCardId,
          customerNumber: user.customerNumber,
          returnUrl: redirectUrl.value,
          paymentRegistration: {
            id: newCard.registrationNo
          }
        });
        changeBankCardRes.current = res.obj;
        const { status, redirectUrl: frameLink } = res.obj;
        switch (status) {
          case _3dsStatus.pendingHasLink:
            setIframeUrl(frameLink);
            break;
          case _3dsStatus.successNoLink:
            onSuccess && onSuccess(res);
            break;
          case _3dsStatus.failed:
            setServerError(changeActiveCardFaildMessage.value);
            break;
          default:
            break;
        }
      } else {
        const res = await api.user.updateBankCard(null, {
          id: card.value,
          defaultFlag: "1",
          paymentToken: PaymentToken,
          userAccount: user.userAccount
        });
        onSuccess && onSuccess(res);
      }
    } else {
      const res = await api.user.addBankCard(null, {
        paymentToken: PaymentToken,
        defaultFlag: "1",
        userAccount: user.userAccount
      });
      onSuccess && onSuccess(res);
    }
  };
  const errorCallback = () => {};
  const renderErrorCallback = () => {};
  const renderSuccessCallback = () => {};
  const resizeCallback = () => {};
  const btnProps = {
    buttonText: ctaName.value,
    colorScheme: colorScheme,
    iconName: iconName,
    callback: debounce(() => {
      arv.current.tokenize();
    }, 500)
  };
  const iframeProps = {
    iframeUrl,
    callback(e) {
      const { serialNo, bankCardId } = changeBankCardRes.current;
      startWatchTransaction(serialNo, bankCardId);
    }
  };
  const widgetStyle = {
    display: iframeUrl ? "none" : "block"
  };
  return (
    <Modal className="add-bank-card-modal" showModal={visible} onCloseClicked={onCloseClicked}>
      <Heading className="heading" type={headingType} html={headingBody} />
      <BodyText className="body" html={body} />
      <div className="arvato-container" style={widgetStyle}>
        <div id={containerId} />
      </div>
      {serverError && <div className="failed-message" dangerouslySetInnerHTML={{ __html: serverError }} />}
      {iframeUrl && <CheckoutPaymentFrame {...iframeProps} />}
      <div className="cta-wrapper">{btnProps && <PrimaryButton {...btnProps} />}</div>
    </Modal>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default connect(mapStateToProps)(BankCardModal);
